module.exports = __webpack_public_path__ + "static/media/about_icon06.4317cba3.png";